import { fetchQueryApi } from './fetchApi'
import {
  paths as cascade_change,
  definitions as cascade_change_definition,
} from './generated/cascade_change'
import { paths as lexical_options } from './generated/lexical_options'

type DatingProfile = lexical_options['/options/dating-profile']
type DatingProfileMethod = DatingProfile['get']
type DatingProfileQuery = DatingProfileMethod['parameters']['query']
type DatingProfileResponse = DatingProfileMethod['responses']['200']['schema']

type CascadeProfileField = cascade_change['/cascade-change/profile-fields/next-field']

type CascadeProfileFieldMethod = CascadeProfileField['get']
type CascadeProfileFieldQuery = CascadeProfileFieldMethod['parameters']['query']
export type CascadeProfileFieldResponse = CascadeProfileFieldMethod['responses']['200']['schema']

export type CascadeProfileFieldType = cascade_change_definition['ProfileFieldCascadeChange']['name']

/**
 * Возвращает словари для профиля знакомств.
 * @returns {Promise<Response>}
 */
export const datingProfileOptionsApi = (field, ...rest) => {
  let names = field

  if (rest.length) {
    names = `${field},`.concat(...rest.join(','))
  }

  return fetchQueryApi<DatingProfileResponse, DatingProfileQuery>(
    '/options/dating-profile',
    {
      names,
    }
  )
}
/**
 *
 * @returns {Promise<*|undefined>}
 */
export const getNextFieldApi = (
  ignoredFields: cascade_change_definition['ProfileFieldCascadeChange']['name']
) => {
  return fetchQueryApi<CascadeProfileFieldResponse, CascadeProfileFieldQuery>(
    '/cascade-change/profile-fields/next-field',
    {
      ignoredFields,
    }
  )
}
